export default __webpack_public_path__ + "static/media/self4-image.0df5a4c6.png";